export const enum Color {
  PRIMARY_COLOR = '#F7B900',
  APPLE = '#34B340',
  MEDIUM_GREEN = '#35B43F',
  LIGHT_GREEN = '#E4F7E5',
  CELESTIAL_BLUE = '#548ED6',
  LIGHT_SHADE_BLUE = '#7879F1',
  BLUE = '#2774CD',
  DEEP_LILAC = '#9845C5',
  FANDANGO = '#B1387F',
  BACKGROUND_COLOR = '#F3E9E0',
  RAISIN_BLACK = '#2C201F',
  ERROR = '#FF5438',
  WHITE = '#FFFFFF',
  BLACK = '#000000',
  GREY = '#F3F3F3',
  SHADOW_GREY = '#F7F7F7',
  LIGHT_GREY = '#EEEEEE',
  TEXT_SECONDARY = '#616161',
  ACCENT = '#FFF7E4',
  BROWNISH_GREY_TWO = '#B0A099',
  BROWNISH_GREY = '#4A3532',
  BG_MAIN = '#F4E8DE',
}

export const enum Place {
  footer = 'footer',
  first = 'first',
  last_section = 'last_section',
  features_section = 'features_section',
  enjoy_the_process = 'enjoy_the_process',
  blog = 'blog',
  cta_block = 'cta_block',
  page_404 = '404',
  header = 'header',
}

export const enum ColorRGB {
  RAISIN_BLACK = '44, 32, 31',
  TEXT_SECONDARY = '97, 97, 97',
  WHITE = '255, 255, 255',
  BROWNISH_GREY_TWO = '176, 160, 153',
  PRIMARY_COLOR = '247, 185, 0',
  APPLE = '52, 179, 64',
}

export const enum ANALYTICS_PAGE {
  MAIN = 'main',
  ABOUT = 'about',
  DOG_TRAINERS = 'dog-trainers',
  BLOG = 'blog',
  PARTNERS_UGC_CREATORS = 'partners_ugc_creators',
  PARTNERS_BUSINESS = 'partners_business',
  CALCULATOR = 'calculator',
  CONTACT = 'contact_us',
  PRIVACY = 'privacy',
  TERMS = 'terms',
  COOKIE = 'cookie',
  CALCULATOR_1 = 'calculator_1',
  CALCULATOR_2 = 'calculator_2',
  CALCULATOR_3 = 'calculator_3',
  CALCULATOR_4 = 'calculator_4',
  CALCULATOR_5 = 'calculator_5',
  CALCULATOR_6 = 'calculator_6',
  CALCULATOR_7 = 'calculator_7',
  CALCULATOR_8 = 'calculator_8',
  AUTO_RENEWAL_AGREEMENT = 'auto-renewal-agreement',
  TERMS_CN = 'terms-of-use-cn',
  PAGE_404 = '404',
}

export const enum PAGE_URL {
  MAIN = 'main',
  ABOUT = 'about',
  DOG_TRAINERS = 'dog-trainers',
  BLOG = 'blog',
  PARTNERS_UGC_CREATORS = 'ugc-creators',
  PARTNERS_BUSINESS = 'business',
  CONTACT = 'contact-us',
  PRIVACY = 'privacy-policy',
  TERMS = 'terms-of-use',
  TERMS_CN = 'terms-of-use-cn',
  COOKIE = 'cookie-policy',
  CALCULATOR = 'calculator',
  AUTO_RENEWAL_AGREEMENT = 'auto-renewal-agreement',
}

export const PAGES_MAP = {
  [PAGE_URL.ABOUT]: ANALYTICS_PAGE.ABOUT,
  [PAGE_URL.DOG_TRAINERS]: ANALYTICS_PAGE.DOG_TRAINERS,
  [PAGE_URL.BLOG]: ANALYTICS_PAGE.BLOG,
  [PAGE_URL.PARTNERS_UGC_CREATORS]: ANALYTICS_PAGE.PARTNERS_UGC_CREATORS,
  [PAGE_URL.PARTNERS_BUSINESS]: ANALYTICS_PAGE.PARTNERS_BUSINESS,
  [PAGE_URL.CONTACT]: ANALYTICS_PAGE.CONTACT,
  [PAGE_URL.TERMS]: ANALYTICS_PAGE.TERMS,
  [PAGE_URL.COOKIE]: ANALYTICS_PAGE.COOKIE,
  [PAGE_URL.PRIVACY]: ANALYTICS_PAGE.PRIVACY,
  [PAGE_URL.CALCULATOR]: ANALYTICS_PAGE.CALCULATOR,
}

export const enum SOCIAL_MEDIA {
  TIK_TOK = 'tik_tok',
  INSTAGRAM = 'instagram',
  YOUTUBE = 'youtube',
  FACEBOOK = 'facebook',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum FirebaseRemoteConfigKey {
  WEBSITE_AMPLITUDE_ANALYTICS = 'website_amplitude_analytics',
  WEBSITE_CONFIG_FILE = 'website_config_file',
}

export const defaultWebSiteConfigFile = {
  web_funnel_link:
    'https://woofz.academy/?cohort=woofz22_v4w&utm_source=woofzwebsite&utm_campaign=hero_banner',
  header_btn_link:
    'https://woofz.academy/?cohort=woofz22_v4w&utm_source=woofzwebsite&utm_campaign=header',
  main_features_section_btn_link:
    'https://woofz.academy/?cohort=woofz22_v4w&utm_source=woofzwebsite&utm_campaign=main_features_section',
}

export const enum Position {
  left = 'left',
  right = 'right',
}

export const enum FacebookPixelEvent {
  PAGE_VIEW = 'PageView',
  WEB_ONB_BTN_CLICKED = 'WebOnbBtnClicked',
  FORM_SUBMITTED = 'FormSubmitted',
}

export const MIN_WIDTH = 360
export const MEDIUM_WIDTH = 389
export const MAX_PHONE = 414
export const BASE_COLUMN_WIDTH = 1024
export const BASE_COLUMN_MAX_WIDTH = 1023
export const BLOG_DESKTOP_COLUMN_WIDTH = 760
export const TRANSITION_DURATION_IN_SECONDS = 0.3
export const CONTACT_US_TARGET_ELEMENT_ID = 'contact-us-target'
export const LOGGER_WAS_INITIALIZED = 'LOGGER_WAS_INITIALIZED'

export const CONTACT_FORM_LINK_PROD = 'https://woofz.com/contact-us'
export const CONTACT_FORM_LINK_DEV =
  'https://woofzdotcom.supernove8.com/contact-us'

export const ENVS = {
  DEV: 'dev',
  PROD: 'prod',
}

export const ENVS_HOSTNAME = ['woofz.com', 'woofzdotcom.supernove8.com']

export const WEBAPP_LINKS = {
  [ENVS.DEV]: 'https://app.supernove8.com?utm_source=woofzwebsite',
  [ENVS.PROD]: 'https://app.woofz.com?utm_source=woofzwebsite',
}

export const PAGE_404_LINK =
  'https://woofz.academy/?cohort=woofz22_v3&utm_source=woofzwebsite&utm_campaign=error_404'

export const TRY_WOOFZ_BUTTON_LINK =
  'https://woofz.academy/?cohort=woofz22_v3&utm_source=woofzwebsite&utm_campaign=header'

export const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const EMAIL_DOMAINS = [
  '@gmail.com',
  '@hotmail.com',
  '@yahoo.com',
  '@outlook.com',
  '@aol.com',
  '@icloud.com',
  '@live.com',
  '@msn.com',
  '@me.com',
  '@mac.com',
  '@googlemail.com',
  '@facebook.com',
  '@verizon.net',
  '@rediffmail.com',
  '@zohomail.com',
  '@zoho.com',
  '@mail.com',
]

export const enum FormState {
  DEFAULT = 'default',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export const enum Lang {
  ES = 'es',
  EN = 'en',
}

export const metaData = {
  en: {
    homepage: {
      title: 'Woofz Dog Training: Best App for Puppies & Dogs',
      description:
        'Explore Woofz - the best app for dog training, puppy care, and health monitoring. Access professional dog trainers 24/7 and start your journey to a well-behaved happy dog!',
    },
    dogTrainers: {
      title: 'Woofz Team of Dog Experts and Trainers',
      description:
        'Meet our professional dog training team! Certified trainers and dog specialists, who are the best in obedience and tricks. Don’t hesitate to ask your questions!',
    },
    aboutUs: {
      title: 'About Woofz: Our Mission and Values',
      description:
        'Learn more about who we are, our mission, and what drives us. Here, you will discover Woofz`s story, values, and commitment to delivering quality and excellence.',
    },
    businessPartner: {
      title: 'Woofz Partnership for Business',
      description:
        'Unlock new growth opportunities with Woofz’s business partnership program. Explore how partnering with us can elevate your business today!',
    },
    creatorsPartner: {
      title: 'Join Woofz as a UGC Creator - Write us!',
      description:
        'We`re looking for talented UGC (User-Generated Content) creators to collaborate with our dog training app!',
    },
    contactUs: {
      title: 'Contact us',
      description:
        'Get in touch with us! Fill in our online contact form, and our team will assist you with any questions or concerns!',
    },
  },
  es: {
    homepage: {
      title: 'Woofz Adiestramiento canino: para cachorros y perros adultos',
      description:
        'Explora Woofz - la mejor app para el entrenamiento canino, el cuidado de tus cachorros. Consulta con los adiestradores profesionales 24/7 y comienza un viaje que te llevará a tener un perro feliz y bien educado.',
    },
    dogTrainers: {
      title: 'Woofz: Equipo de expertos y entrenadores caninos',
      description:
        '¡Conoce a nuestro equipo de entrenadores profesionales! Entrenadores certificados y especialistas en obediencia y trucos. ¡No dudes en hacernos tus preguntas!',
    },
    aboutUs: {
      title: 'Sobre Woofz: Nuestra misión y valores',
      description:
        'Conoce quiénes somos, nuestra misión y lo que nos mueve. Aquí descubrirás la historia, los valores y el compromiso de Woofz con la calidad y la excelencia.',
    },
    businessPartner: {
      title: 'Woofz Partnership para empresas',
      description:
        'Desbloquea nuevas oportunidades para crecer con el programa para empresas Woofz partnership. Descubre cómo asociarte con nosotros puede potenciar tu negocio.',
    },
    creatorsPartner: {
      title: 'Únete a Woofz como Creador de UGC – ¡Escríbenos!',
      description:
        '¡Buscamos talentosos creadores de UGC (Contenido generado por usuarios) para colaborar en nuestra app de adiestramiento canino!',
    },
    contactUs: {
      title: 'Contáctanos',
      description:
        '¡Ponte en contacto con nosotros! Completa nuestro formulario online y nuestro equipo te ayudará con cualquier pregunta o inquietud.',
    },
  },
}

export const LanguagesNames = {
  [Lang.ES]: 'Español',
  [Lang.EN]: 'English',
}

export const URLS = {
  about: {
    [Lang.EN]: '/about',
    [Lang.ES]: '/sobre-nosotros',
  },
  homepage: {
    [Lang.EN]: '/',
    [Lang.ES]: '/',
  },
  'dog-trainers': {
    [Lang.EN]: '/dog-trainers',
    [Lang.ES]: '/adiestradores-caninos',
  },
  'ugc-creators': {
    [Lang.EN]: '/partners/ugc-creators',
    [Lang.ES]: '/socios/creadores-ugc',
  },
  business: {
    [Lang.EN]: '/partners/business',
    [Lang.ES]: '/socios/negocios',
  },
  'contact-us': {
    [Lang.EN]: '/contact-us',
    [Lang.ES]: '/contactar',
  },
  'terms-of-use': {
    [Lang.EN]: '/terms-of-use',
    [Lang.ES]: '/terms-of-use',
  },
  'cookie-policy': {
    [Lang.EN]: '/cookie-policy',
    [Lang.ES]: '/cookie-policy',
  },
  'privacy-policy': {
    [Lang.EN]: '/privacy-policy',
    [Lang.ES]: '/privacy-policy',
  },
}
